import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import creditService from '../../../utils/creditService';

const ValidationStats = ({ userCredits, refreshTrigger = 0, onRefreshCredits }) => {
  // Use credit information passed from parent component
  const stats = userCredits ? {
    credits_remaining: userCredits.credits_remaining || 0,
    credits_total: userCredits.credits_total || 0,
    credits_used: userCredits.credits_used || 0,
    subscription_plan: userCredits.subscription_plan || 'free',
    billing_cycle: userCredits.billing_cycle || 'monthly',
    is_unlimited: userCredits.is_unlimited || false
  } : null;

  if (!stats) {
    return (
      <div className="bg-surface border border-border rounded-lg p-6">
        <div className="flex items-center justify-center h-48">
          <div className="text-center">
            <Icon name="CreditCard" size={24} className="text-text-secondary mx-auto mb-2" />
            <p className="text-text-secondary">No credit information available</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-surface border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
            <Icon name="CreditCard" size={20} className="text-primary" />
          </div>
          <div>
            <h3 className="text-lg font-medium text-text-primary">Credit Information</h3>
            <p className="text-sm text-text-secondary">
              Your email validation credits
            </p>
          </div>
        </div>
        
        {onRefreshCredits && (
          <Button
            variant="outline"
            size="sm"
            onClick={onRefreshCredits}
            className="flex items-center space-x-2"
          >
            <Icon name="RefreshCw" size={16} />
            <span>Refresh</span>
          </Button>
        )}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="text-center p-4 bg-primary/10 rounded-lg">
          <div className="text-2xl font-bold text-primary">
            {creditService.formatCreditsDisplay(stats.credits_remaining)}
          </div>
          <div className="text-xs text-primary">Available Credits</div>
        </div>
        
        <div className="text-center p-4 bg-accent/10 rounded-lg">
          <div className="text-2xl font-bold text-accent">
            {creditService.formatCreditsDisplay(stats.credits_total)}
          </div>
          <div className="text-xs text-accent">Total Credits</div>
        </div>
        
        <div className="text-center p-4 bg-warning/10 rounded-lg">
          <div className="text-2xl font-bold text-warning">
            {stats.credits_used?.toLocaleString() || 0}
          </div>
          <div className="text-xs text-warning">Used Credits</div>
        </div>
        
        <div className="text-center p-4 bg-success/10 rounded-lg">
          <div className="text-2xl font-bold text-success">
            {stats.is_unlimited ? 'Unlimited' : stats.subscription_plan || 'free'}
          </div>
          <div className="text-xs text-success">Plan</div>
        </div>
      </div>

      {stats.is_unlimited && (
        <div className="mt-4 p-3 bg-success/10 border border-success/20 rounded-lg">
          <div className="flex items-center space-x-2">
            <Icon name="Infinity" size={16} className="text-success" />
            <span className="text-sm text-success font-medium">Unlimited Plan - No Credit Limits</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ValidationStats;